import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FF6B00]/20 py-10 px-4" data-id="element-57">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4" data-id="element-59">
          🌟 PROFEPACK
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-60">
          El sistema de planificación N°1 para docentes de Inglés de primaria y
          secundaria en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-61">
          Porque enseñar Inglés no debería costarte todos los domingos del año.
        </p>
        <div className="h-px bg-[#FF6B00]/20 mb-6" data-id="element-62" />
        <p className="text-gray-400 text-xs" data-id="element-63">
          © PROFEPACK — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}